<template>
    <ul class="list-group">
        <li class="list-group-item c-pointer px-75 py-50" v-on:click="goPersonal(p)" v-for="p in value.Personal" :key="p.Id">{{p.FullName}}</li>
    </ul>
</template>

<script>
export default {
    props:{
        value:Object
    },
    methods:{
        goPersonal(item){
            this.$router.push({name:'employee-create-or-update',params:{id:item.Id},query:{from:'departments'}})
        }
    }
}
</script>

<style>

</style>